import { IQueryTableWithQuerySelects } from "src/app/view-model/query-builder.view-model";
import { DatasetSortingOrderType } from "../../../query.constants";

export class DatasetSorting {

  constructor() { }

  getSortOrderFromCurrentSortColumn(
    tableAlias: string | null,
    columnName: string,
    primarySortColumn: string | null = null,
    secondarySortColumn: string | null = null
  ): DatasetSortingOrderType | undefined {
    let tempColumnFromDB = '';
    primarySortColumn = (primarySortColumn) ? this.addBoxToColumn(primarySortColumn) : primarySortColumn;
    secondarySortColumn = (secondarySortColumn) ? this.addBoxToColumn(secondarySortColumn) : secondarySortColumn;
    tempColumnFromDB = (tableAlias !== null && tableAlias !== '') ? `[${tableAlias}].[${columnName}]` : `[${columnName}]`;

    if (primarySortColumn !== null && primarySortColumn?.includes(tempColumnFromDB)) {
      if (primarySortColumn.includes('ASC')) {
        return '~PRIMARYAZ~';
      } else if (primarySortColumn.includes('DESC')) {
        return '~PRIMARYZA~';
      }
    } else if (secondarySortColumn !== null && secondarySortColumn?.includes(tempColumnFromDB)) {
      if (secondarySortColumn.includes('ASC')) {
        return '~SECONDARYAZ~';
      } else if (secondarySortColumn.includes('DESC')) {
        return '~SECONDARYZA~';
      }
    } else {
      return `~NOSORT~`;
    }
    return undefined;
  }

  /**
  * The sort order for a query is stored in the sortColumns in the query table "[PrimaryTableAlias].[PrimaryColumnAlias],[SecondaryTableAlias].[SecondaryColumnAlias]".
  * This method applies the sort for the query with the selected dataset column returns the string to be stored in the SortColumns in the Query Table.
  * @param selectedSort - Selected sort order of type DatasetSortingOrderType.
  * @param tableAlias - Table Alias of the column for which sort is to be applied. If TableAlias is null it is a sorted column, if TableAlias has string value it's a regular table column.
  * @param columnName - Column Alias of the column for which sort is to be applied.
  * @param sortColumns - Current Dataset Sort saved for Query.
  * @returns String - which needs to be saved for the query.  
  * @returns null - if both primary and secondary sort needs to be removed.
  * @returns '' (empty string) - if nothing should happen and there's no change in the current sort order.
  */
  applySortToDatasetColumn(
    selectedSort: DatasetSortingOrderType,
    tableAlias: string | null,
    columnName: string,
    sortColumns: string | null | undefined): string | null | undefined {

    let tempSortColumns: string | null = '';
    let tempCompleteSortOrderInDB = '';
    let primarySecondaryNosortFlag: 'PRIMARY' | 'SECONDARY' | 'NOSORT';
    const radioButtonSelectedValue = selectedSort;
    let sortColumnCompleteDBName = '';
    if (tableAlias !== null && tableAlias !== '') {
      sortColumnCompleteDBName = `[${tableAlias}].[${columnName}]`
    } else {
      sortColumnCompleteDBName = `[${columnName}]`;
    }
    if (radioButtonSelectedValue.includes('PRIMARY')) {
      primarySecondaryNosortFlag = 'PRIMARY';
    } else if (radioButtonSelectedValue.includes('SECONDARY')) {
      primarySecondaryNosortFlag = 'SECONDARY';
    } else {
      primarySecondaryNosortFlag = 'NOSORT';
    }

    if (radioButtonSelectedValue.includes('AZ~')) {
      tempCompleteSortOrderInDB = `${sortColumnCompleteDBName} ASC`;
    } else if (radioButtonSelectedValue.includes('ZA~')) {
      tempCompleteSortOrderInDB = `${sortColumnCompleteDBName} DESC`;
    } else {
      tempCompleteSortOrderInDB = 'NOSORT';
    }

    const hasSortColumns = sortColumns !== undefined && sortColumns !== null;
    let splitSortColumns = sortColumns ? this.splitAndAddBoxToSortColumns(sortColumns) : [];

    if (primarySecondaryNosortFlag === 'NOSORT'
      && ((!hasSortColumns && splitSortColumns.length === 1 && !splitSortColumns[0].includes(sortColumnCompleteDBName))
        || (!hasSortColumns && splitSortColumns.length === 2 && !splitSortColumns[0].includes(sortColumnCompleteDBName) && !splitSortColumns[1].includes(sortColumnCompleteDBName)))) {
      return;
    } else if ((!hasSortColumns
      || (splitSortColumns.length === 1 && splitSortColumns[0].includes(sortColumnCompleteDBName)))
      && (primarySecondaryNosortFlag !== 'NOSORT')) {
      tempSortColumns = tempCompleteSortOrderInDB;
    } else if (splitSortColumns.length === 1) {
      if (!splitSortColumns[0].includes(sortColumnCompleteDBName)) {
        if (primarySecondaryNosortFlag === 'PRIMARY') {
          tempSortColumns = `${tempCompleteSortOrderInDB},${splitSortColumns[0].trim()}`;
        } else if (primarySecondaryNosortFlag === 'SECONDARY') {
          tempSortColumns = `${splitSortColumns[0].trim()},${tempCompleteSortOrderInDB}`;
        }
      } else if (primarySecondaryNosortFlag === 'NOSORT') {
        tempSortColumns = null;
      }
    }
    else if (splitSortColumns.length === 2) {
      if (!splitSortColumns[0].includes(sortColumnCompleteDBName)
        && !splitSortColumns[1].includes(sortColumnCompleteDBName)) {
        if (primarySecondaryNosortFlag === 'PRIMARY') {
          tempSortColumns = `${tempCompleteSortOrderInDB},${splitSortColumns[0].trim()}`;
        } else if (primarySecondaryNosortFlag === 'SECONDARY') {
          tempSortColumns = `${splitSortColumns[0].trim()},${tempCompleteSortOrderInDB}`;
        }
      } else if (splitSortColumns[0].includes(sortColumnCompleteDBName) && primarySecondaryNosortFlag !== 'NOSORT') {
        if (primarySecondaryNosortFlag === 'PRIMARY') {
          tempSortColumns = `${tempCompleteSortOrderInDB},${splitSortColumns[1].trim()}`;
        } else if (primarySecondaryNosortFlag === 'SECONDARY') {
          tempSortColumns = `${splitSortColumns[1].trim()},${tempCompleteSortOrderInDB}`;
        }
      } else if (splitSortColumns[1].includes(sortColumnCompleteDBName) && primarySecondaryNosortFlag !== 'NOSORT') {
        if (primarySecondaryNosortFlag === 'PRIMARY') {
          tempSortColumns = `${tempCompleteSortOrderInDB},${splitSortColumns[0].trim()}`;
        } else if (primarySecondaryNosortFlag === 'SECONDARY') {
          tempSortColumns = `${splitSortColumns[0].trim()},${tempCompleteSortOrderInDB}`;
        }
      } else if (primarySecondaryNosortFlag === 'NOSORT') {
        if (splitSortColumns[0].includes(sortColumnCompleteDBName)) {
          tempSortColumns = splitSortColumns[1].trim();
        } else if (splitSortColumns[1].includes(sortColumnCompleteDBName)) {
          tempSortColumns = splitSortColumns[0].trim();
        }
      }
    }
    return tempSortColumns;
  }

  /**
   * transforms both sort s into [tableAlias].[columnName] asc , [tableAlias].[columnName] desc
   * @param sortColumns 
   * @returns 
   */
  splitAndAddBoxToSortColumns(sortColumns: string) {
    //// tablealias.columnName asc , tableAlias2.columnName2 desc
    let splitSortColumns = sortColumns ? sortColumns.split(',')?.filter(item => item !== '') : [];
    let splitSortColumnsWithBox: string[] = [];
    splitSortColumns.forEach(acolumn => {
      splitSortColumnsWithBox.push(this.addBoxToColumn(acolumn));
    });
    return splitSortColumnsWithBox;
  }

  /**
   * To place a single sortcolumn with in []
   * @param column 
   * @returns tranforms tableAlias.columnName ASc -> [tableAlias].[columnName] asc
   */
  addBoxToColumn(column: string) {
    if (column && column.indexOf('[') < 0) {
      let columnAndSortBySplit = column.split(' ');
      let aSortColumnarray = columnAndSortBySplit[0].split('.');
      // try to add [] to existing sortcolumns without [] 
      return (aSortColumnarray.length > 1) ? `[${aSortColumnarray[0]}].[${aSortColumnarray[1]}] ${columnAndSortBySplit?.[1]}` : `[${aSortColumnarray[0]}] ${columnAndSortBySplit?.[1]}`;
    }
    return column;
  }

  /**
  * This method takes current sort order column as input and extracts primary and secondary sorted columns.
  * @param currentSortColumns - current sort order.
  * @returns array of sorted columns  [tableAlias].[ColumnAlias] asc/desc format.  
  */
  getSortColumnsFromSortOrder(currentSortColumns: string) {
    let primarySortColumn = null;
    let secondarySortColumn = null;
    const tempCurrentSortColumnsArray = currentSortColumns?.split(',');
    if (currentSortColumns === null) {
      primarySortColumn = null;
      secondarySortColumn = null;
    } else if (tempCurrentSortColumnsArray !== undefined
      && tempCurrentSortColumnsArray.length === 1) {
      primarySortColumn = tempCurrentSortColumnsArray[0];
      secondarySortColumn = null;
    } else if (tempCurrentSortColumnsArray !== undefined
      && tempCurrentSortColumnsArray.length > 1) {
      primarySortColumn = tempCurrentSortColumnsArray[0];
      secondarySortColumn = tempCurrentSortColumnsArray[1];
    }
    return [primarySortColumn, secondarySortColumn];
  }

  /** method to replace alias name in sortOoder input privided
 * @param sortOrder - Selected sort order of type DatasetSortingOrderType.
 * @param oldAlias - old value to replce.
 * @param newAlias - new value to replace with.
 * @param indexToreplace -index of item in  column  0- if table names 1- for column [tablename-index 0].[columnname- index 1]
 * @returns String - updated sortOrder string .  
 */
  replaceAliasInSortOrder(sortOrder: string, oldAlias: string, newAlias: string, indexToReplace: number, isCalculatedColumn: boolean = false) {
    let find = indexToReplace == 0 ? `[${oldAlias}].` : isCalculatedColumn ? `[${oldAlias}]` : `.[${oldAlias}]`;
    let replace = indexToReplace == 0 ? `[${newAlias}].` : isCalculatedColumn ? `[${newAlias}]` : `.[${newAlias}]`;
    return sortOrder.replace(find, replace);
  }


  /** method to get sortColumn name based on column type. for calculated column it would be columnalias &  for db columns , its just columnname 
 * @param column - Selected sort order of type DatasetSortingOrderType.
 * @returns String - column name to store as sortcolumn
 */
  getColumnNameToSort(column : IQueryTableWithQuerySelects)
  {
     return column.queryTableId === -1 ?  column.columnAlias: column.columnName;
  }


}